import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateByDayjs } from '@/utils';
import { StatusAnnotation } from '@/types';
import { MessageCircle } from 'lucide-react';

interface OrderCommentsProps {
  statusAnnotationsData: StatusAnnotation[];
}

const OrderComments: React.FC<OrderCommentsProps> = ({ statusAnnotationsData }) => {
  const { t } = useTranslation();
  // The carrier never addresses the merchant (owner 2026-10-28: no carrier
  // on any merchant screen), so only Boxy support comments render here.

  if (statusAnnotationsData.length === 0) {
    return null;
  }

  return (
    <div className='sd-scope sd-font rounded-2xl border border-sd-border bg-sd-card p-5 mb-4'>
      {/* Boxy Support Comments */}
      {statusAnnotationsData && statusAnnotationsData.length > 0 && (
        <div>
          <div className='flex items-center gap-2 mb-3'>
            <MessageCircle className='w-4 h-4 text-sd-muted-foreground' />
            <h3 className='text-[13px] font-bold uppercase tracking-wider text-sd-muted-foreground m-0'>
              {String(t('support_comments'))}
            </h3>
          </div>
          <div className='space-y-3'>
            {statusAnnotationsData.map((comment, index) => (
              <div
                key={index}
                className='rounded-xl border border-sd-border bg-sd-muted/30 p-3'
              >
                <p className='text-[11px] text-sd-muted-foreground m-0 mb-1'>
                  {formatDateByDayjs(comment.created_at, 'D MMMM YYYY, HH:mm')}
                </p>
                {comment.status_annotation_tag && (
                  <p className='text-[12px] font-semibold text-sd-foreground m-0 mb-1'>
                    {comment.status_annotation_tag?.title}
                  </p>
                )}
                {comment.text && (
                  <p className='text-[13px] text-sd-foreground m-0'>
                    {comment.text}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default OrderComments;
